import React from 'react';
import AlertDialog from './AlertDialog';
import {View} from 'react-native';
import LoadingSpinner from './LoadingSpinner';

export default function AsterixDialog({isSwitching, message}) {
  const cancelRef = React.useRef(null);

  return (
    <AlertDialog leastDestructiveRef={cancelRef} isOpen={isSwitching}>
      <AlertDialog.Content>
        <AlertDialog.Header>Please wait</AlertDialog.Header>
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            columnGap: 10,
            padding: 10,
            marginLeft: 8,
          }}>
          <LoadingSpinner size="small" />
          <View>
            <AlertDialog.Body>{message}</AlertDialog.Body>
          </View>
        </View>
      </AlertDialog.Content>
    </AlertDialog>
  );
}
